import { TimelineMax, Sine } from 'gsap';

const StoneFloating = (stone) => {
  const tl = new TimelineMax({ paused: true, repeat: -1, yoyo: true });
  tl.addLabel('start')
    .to(stone.position, 2, {
      y: '+=30',
      ease: Sine.easeInOut,
    });
  return tl;
};

export default StoneFloating;
